/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import {
  LAW_FIRM_ADDRESS,
  LAW_FIRM_ADDRESS_LOCALITY,
  LAW_FIRM_FAX,
  LAW_FIRM_NAME,
  LAW_FIRM_POSTAL_CODE,
  SERVICE_EMAIL,
  SERVICE_PHONE,
  SERVICE_PHONE_INTERNATIONAL,
} from "@/src/services/globalVars";
import imprintStyle from "./imprintStyle";
import Container from "@/src/components/Container/Container";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import { Link } from "react-router";

const Imprint = () => {
  return (
    <Container showVerticalPadding={false}>
      <Box sx={imprintStyle.impressum} id="impressum">
        <Typography variant={"h1"}>Impressum</Typography>
        <p>
          <strong>Verantwortlich gemäß § 18 Abs. 2 MStV:</strong>
          <br />
          <br />
          Rechtsanwalt Frank Riedel
          <br />
          {LAW_FIRM_NAME}
          <br />
          {LAW_FIRM_ADDRESS}
          <br />
          {LAW_FIRM_POSTAL_CODE} {LAW_FIRM_ADDRESS_LOCALITY}
          <br />
          <br />
          <strong>Geschäftsführung</strong>
          <br />
          Michael Bick, Lara von Kolontaj, Frank Riedel, Anna Wagner
          <br />
          <br />
          <strong>Kontakt</strong>
          <br />
          Kundenservice: <a href={"mailto:" + SERVICE_EMAIL}>{SERVICE_EMAIL}</a>
          <br />
          Telefonnummer: <a href={`tel:${SERVICE_PHONE_INTERNATIONAL}`}>{SERVICE_PHONE}</a>
          <br />
          Geschäftliche / rechtliche Anfragen: <a href={"mailto:" + SERVICE_EMAIL}>{SERVICE_EMAIL}</a>
          <br />
          Fax.: {LAW_FIRM_FAX}
          <br />
          Eingetragen beim Amtsgericht Köln
          <br />
          HRB 97467 | USt-ID DE324640771
          <br />
          <br />
          <strong>Informationen nach § 2 DL-InfoV</strong>
          <br />
          Die genannten gesetzlichen Berufsbezeichnungen „Rechtsanwalt“ bzw. „Rechtsanwältin“ sowie Fachanwaltsbezeichnungen wurden sämtlich in der
          Bundesrepublik Deutschland verliehen.
          <br />
          <br />
          <strong>Zuständige Aufsichtsbehörde (iSv. § 5 Abs. 1 Nr. 3 DDG):</strong>
          <br />
          Rechtsanwaltskammer Köln
          <br />
          Riehler Strasse 30
          <br />
          50668 Köln
          <br />
          <br />
          Tel. 0221-97 30 10-0
          <br />
          Fax. 0221-97 30 10-50
          <br />
          E-Mail: <a href="mailto:kontakt@rak-koeln.de">kontakt@rak-koeln.de</a>
          <br />
          <br />
          <strong>Berufshaftpflichtversicherung</strong>
          <br />
          HDI Versicherung AG
          <br />
          HDI-Platz 1<br />
          30659 Hannover
          <br />
          <br />
          Der räumliche Geltungsbereich des Versicherungsschutzes umfasst Tätigkeiten in den Mitgliedstaaten der Europäischen Union.
          <br />
          <br />
          <strong>Berufsrechtliche Regelungen</strong>
          <br />
          <ul>
            <li>Berufsordnung für Rechtsanwälte (BORA)</li>
            <li>Bundesrechtsanwaltsordnung (BRAO)</li>
            <li>Rechtsanwaltsvergütungsgesetz (RVG)</li>
            <li>Berufsregeln der Rechtsanwälte der Europäischen Union (CCBE)</li>
            <li>Fachanwaltsordnung (FAO)</li>
          </ul>
          Diese Gesetze und Verordnungen sind im Bundesgesetzblatt veröffentlicht.
          <br />
          Sie können auch über die Bundesrechtsanwaltskammer bezogen werden und befinden sich zudem auf ihrer Internetseite unter{" "}
          <a href="https://www.brak.de" target="_blank" rel="noopener noreferrer nofollow">
            {" "}
            www.brak.de{" "}
          </a>
          .<br />
          <br />
          <strong>Hinweis auf EU-Streitschlichtung</strong>
          <br />
          Die europäische Webseite für Online-Schlichtungen ist:
          <a href="http://ec.europa.eu/consumers/odr/"> http://ec.europa.eu/consumers/odr/</a> <br />
          Wir sind zur Teilnahme an der Streitschlichtung weder verpflichtet, noch nehmen wir hieran freiwillig teil.
          <br />
          <br />
          <strong>Datenschutz</strong>
          <br />
          Die Datenschutzerklärung der Legalbird Rechtsanwälte Rechtsanwalts GmbH finden Sie
          <Link to={"/datenschutz"}> hier</Link>.
        </p>
      </Box>
    </Container>
  );
};

export default Imprint;
